import Reflux from 'reflux';

const TaskActions = Reflux.createActions([
  'initCategories',
  'readCategories',
  'readCategoriesComplete'
]);

export default TaskActions;



// WEBPACK FOOTER //
// ./src/js/actions/Category.js